"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  id: 1,
  value: "90%",
  label: "Redução de Riscos Operacionais"
}, {
  id: 2,
  value: "4x",
  label: "Inspeções Mais Rápidas"
}, {
  id: 3,
  value: "100%",
  label: "Conformidade de Segurança"
}, {
  id: 4,
  value: "0",
  label: "Necessidade de Entrada Humana"
}];
export default function NossaAgilidadeEmNumeros() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="177502" id="impacto-em-números" className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 z-0 opacity-5 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608045/img/topographic_map_pattern_dark.png')] bg-cover bg-center bg-no-repeat pointer-events-none mix-blend-overlay" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 md:gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {stats.map((stat, i) => <div key={stat.id} data-index={i} className="flex flex-col items-center justify-center text-center space-y-3">
              <span className="font-mono text-6xl md:text-7xl lg:text-8xl font-bold text-primary tracking-tighter drop-shadow-[0_0_15px_rgba(88,179,59,0.3)]">
                {stat.value}
              </span>
              <span className="text-sm md:text-base text-muted-foreground font-semibold uppercase tracking-widest">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}